import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';

console.json = function (obj, label = "") {
  console.log(label + JSON.stringify(obj, null, 2));
};
console.nativeWarn = console.warn;
console.warn = function (warning) {
  let warnFilters = [
    "Warning: componentWillMount has been renamed",
    "Warning: componentWillUpdate has been renamed",
    "Warning: componentWillReceiveProps has been renamed"
  ];
  for (let i = 0; i < warnFilters.length; i++) {
    if (warning.indexOf(warnFilters[i]) === 0) {
      return;
    }
  }
  console.nativeWarn(warning);
}

ReactDOM.render(<App/>, document.getElementById('root'));
// disable ServiceWorker
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js